const BRANCH_TYPE = Object.freeze({
  PICK: "pick",
  RETURN: "return",
});

export default {
  TYPE: BRANCH_TYPE,
};
